import { render, staticRenderFns } from "./pt-route-card.vue?vue&type=template&id=50908664&"
import script from "./pt-route-card.vue?vue&type=script&lang=js&"
export * from "./pt-route-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports